import React from 'react'

const Typeform = () => {
  return (
    <>
      <h5>
        <b>Typeform</b>
      </h5>
      <p>
        Typeform allows you to easily embed surveys and other templates from Typeform to your web
        app. The plugin integration is simple
      </p>
      <br />
    </>
  );
}

export default Typeform